// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c94754d6","391":"d3b6469e","660":"a4558b04"}[chunkId] + ".chunk.js";
};